import { createPortal } from 'react-dom';

/**
 * Rend ses enfants dans `document.body` via un portail React.
 *
 * Pourquoi : `.main-content` (App.css) a `position: relative; z-index: 1`, ce qui
 * crée un *stacking context*. Tout overlay `position: fixed` rendu À L'INTÉRIEUR
 * de `.main-content` est piégé dans ce contexte (z-index 1) et se retrouve donc
 * peint SOUS la sidebar — même avec un z-index interne très élevé. Le portail fait
 * remonter le modal au niveau de `document.body`, hors du stacking context, où son
 * z-index est enfin pris en compte face à la sidebar.
 *
 * Cf. commentaire dans App.css (.main-content) : « vérifie que tous les modaux du
 * module concerné sont rendus en React Portal pour échapper au stacking context ».
 */
export default function ModalPortal({ children }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
